import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PopupVideoComponent } from 'src/app/shared/components/popup-video/popup-video.component';

@Component({
  selector: 'app-industrial',
  templateUrl: './industrial.component.html',
  styleUrls: ['./industrial.component.scss'],
})

export class IndustrialComponent implements OnInit {


  constructor(public dialog: MatDialog) { }
  ngOnInit(): void {
  }
  goToFile(file:string){
    // this.route.navigateByUrl('../../../../../assets/files/Presentación Página Web qAIRa.pdf');
    var a = document.createElement('a');
    a.target="_blank";
    a.href=file;
    a.click()
  }
  viewVideo(video:string){
    this.dialog.open(PopupVideoComponent,{
      data:video
    })
  }
}
